export default __webpack_public_path__ + "static/media/sam-kingston-resume-07-2022.097e17da.pdf";